import { useState } from "react";
import PageOrderComponent from "./shoppingComponent/PageOrderComponent";
import PageAddressComponent from "./shoppingComponent/PageAddressComponent";

export default function ShoppingCart({ setData, user }) {
  const [loadingProcess, setLoadingProcess] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectdAddressId, setSetselectdAddressId] = useState(0);

  const handleNextProcess = () => {
    setPageNumber(pageNumber + 1);
  };
  const handlePrevProcess = () => {
    setPageNumber(pageNumber - 1);
  };
  return (
    <>
      <main className="page-container cart-container mt-4">
        <div className="container">
          <div className="page-context cart-context">
            <h1 className="page-title cart-title">
              {pageNumber == 0
                ? "سبدخرید"
                : pageNumber == 1
                ? "ثبت سفارش"
                : null}
            </h1>
            <div style={{ display: "block" }}>
              <div>
                {pageNumber == 0 ? (
                  <PageOrderComponent
                    handleNextProcess={handleNextProcess}
                    cart={user.cart}
                    setData={setData}
                  />
                ) : pageNumber == 1 ? (
                  <PageAddressComponent
                    setLoadingProcess={setLoadingProcess}
                    handlePrevProcess={handlePrevProcess}
                    handleNextProcess={handleNextProcess}
                    selectdAddressId={selectdAddressId}
                    setSetselectdAddressId={setSetselectdAddressId}
                  />
                ) : null}
              </div>
            </div>
            <div
              className={
                "page-loading cart-loading" + (!loadingProcess ? " d-none" : "")
              }
            >
              <i className="fa fa-refresh fa-spin fa-fw" />
              کمی صبر کنید...
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
